export default __webpack_public_path__ + "static/contacts_header-f958dd554d38182d93ccec44fbfa4b51.jpg";